(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bl-finish-swatches')) {
    class BlFinishSwatches extends HTMLElement {
      connectedCallback() {
        this.dots = [...this.querySelectorAll('.bl-swatches__dot')];
        this.dots.forEach((dot) => {
          dot.addEventListener('click', (event) => {
            event.stopPropagation(); /* the slide's own click selects slides */
            this.choose(dot);
          });
          dot.addEventListener('keydown', (event) => this.onKey(event, dot));
        });
        const first = this.dots.find((d) => d.getAttribute('aria-checked') === 'true');
        this.dots.forEach((d) => (d.tabIndex = d === first ? 0 : -1));
      }

      onKey(event, dot) {
        const keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
        if (!(event.key in keys)) return;
        event.preventDefault();
        const i = (this.dots.indexOf(dot) + keys[event.key] + this.dots.length) % this.dots.length;
        this.choose(this.dots[i]);
        this.dots[i].focus();
      }

      choose(dot) {
        const finish = dot.dataset.finish;
        this.dots.forEach((d) => {
          const on = d === dot;
          d.setAttribute('aria-checked', String(on));
          d.tabIndex = on ? 0 : -1;
        });
        this.querySelectorAll('.bl-pslide__pic').forEach((pic) => {
          pic.hidden = pic.dataset.finish !== finish;
        });
        const name = this.querySelector('.bl-swatches__name');
        if (name) name.textContent = dot.dataset.name;
        const base = this.dataset.baseUrl;
        const slide = this.closest('slideshow-slide') || this.parentElement;
        if (base && slide) {
          const url = dot.dataset.variant ? `${base.split('?')[0]}?variant=${dot.dataset.variant}` : base;
          slide.querySelectorAll('[data-finish-link]').forEach((a) => (a.href = url));
        }
      }
    }
    customElements.define('bl-finish-swatches', BlFinishSwatches);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-policy-panel"] && !Shopify.designMode) return;
  try {
    (() => {
    const panelOf = () => document.querySelector('[data-pdp="policy-panel"]');

    const select = (dialog, name) => {
      dialog.querySelectorAll('[data-pdp-policy-tab]').forEach((tab) => {
        tab.setAttribute('aria-selected', String(tab.dataset.pdpPolicyTab === name));
      });
      dialog.querySelectorAll('[data-pdp-policy-panel]').forEach((pane) => {
        pane.hidden = pane.dataset.pdpPolicyPanel !== name;
      });
      const scroll = dialog.querySelector('.pdp-policy-panel__scroll');
      if (scroll) scroll.scrollTop = 0;
    };

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const link = target.closest('a[data-pdp-policy]');
      if (link) {
        const dialog = panelOf();
        const name = link.dataset.pdpPolicy;
        // No panel, or no text for this policy: let the link go to the policy page.
        if (!dialog || !dialog.querySelector(`[data-pdp-policy-panel="${name}"]`)) return;
        // Open-in-new-tab and similar clicks belong to the browser.
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        select(dialog, name);
        if (!dialog.open) dialog.showModal();
        return;
      }

      const dialog = target.closest('[data-pdp="policy-panel"]');
      if (!dialog) return;
      const tab = target.closest('[data-pdp-policy-tab]');
      if (tab) return select(dialog, tab.dataset.pdpPolicyTab);
      // A click on the dialog element itself is a click on the backdrop.
      if (target.closest('[data-pdp-policy-close]') || target === dialog) dialog.close();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      const tab = event.target instanceof Element ? event.target.closest('[data-pdp-policy-tab]') : null;
      if (!tab) return;
      const tabs = [...tab.parentElement.querySelectorAll('[data-pdp-policy-tab]')];
      const next = tabs[(tabs.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
      next.focus();
      select(tab.closest('[data-pdp="policy-panel"]'), next.dataset.pdpPolicyTab);
    });

    // Phone: swipe the sheet's head down to close.
    let startY = null;
    document.addEventListener('touchstart', (event) => {
      const head = event.target instanceof Element ? event.target.closest('[data-pdp-policy-head]') : null;
      startY = head ? event.touches[0].clientY : null;
    }, { passive: true });
    document.addEventListener('touchend', (event) => {
      if (startY === null) return;
      const moved = event.changedTouches[0].clientY - startY;
      startY = null;
      if (moved > 60) panelOf()?.close();
    }, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
